module.exports = __webpack_public_path__ + "icomoon.2ff40c51ead699238137";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/assets/vendors/by_hands/font-icomoon/fonts/icomoon.woff?mkks98
// module id = ../../../../../src/assets/vendors/by_hands/font-icomoon/fonts/icomoon.woff?mkks98
// module chunks = styles